import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useAuth } from "../libs/AuthContext";

export default function UnauthenticatedRoute() {
  const { isAuthenticated } = useAuth();
  const [params] = useSearchParams();
  if (isAuthenticated) {
    const redirect = params.get("redirect");
    return <Navigate to={redirect && redirect !== "" ? redirect : "/"} replace />;
  }
  return <Outlet />;
}
